import { Popconfirm } from 'antd';
import styled from 'styled-components';

export default styled(Popconfirm)`
	// Add your styles here
`;
